import Model, { attr, belongsTo, hasMany } from "@ember-data/model";

export default class LoadBalancerModel extends Model {
  @attr cost;
  @attr datacenter;
  @attr managedhosting;
  @attr name;
  @attr ipv4;
  @attr ipv6;

  @belongsTo("project", { async: false, inverse: "loadBalancers" }) project;
  @hasMany("load-balancer-certificate", { async: true, inverse: "loadBalancer" }) certificates;
  @hasMany("load-balancer-error", { async: true, inverse: "loadBalancer" }) loadBalancerErrors;
  @hasMany("reserved-ip", { async: false, inverse: null }) ips;
  @hasMany("load-balancer-listener", { async: false, inverse: "loadBalancer" }) listeners;

  get isManagedHosting() {
    return this.managedhosting === "yes";
  }

  get ipv4Addresses() {
    return this.ips.filter((ip) => ip.version === 4).map((ip) => ip.address);
  }

  get ipv6Addresses() {
    return this.ips.filter((ip) => ip.version === 6).map((ip) => ip.address);
  }

  get dirtyListeners() {
    return this.hasMany("listeners")
      .value()
      ?.filter((listener) => listener.isDirty);
  }

  get hasDirtyListeners() {
    return this.dirtyListeners?.length > 0;
  }

  get hasLegacyIp() {
    return Boolean(
      this.hasMany("ips")
        .value()
        ?.some((ip) => ip.platforms?.includes("OpenVZ") || ip.platforms?.includes("VMware")),
    );
  }
}
